/* Built In Imports */
import React, { useEffect, useState } from 'react';
/* External Imports */
import { Box, Flex, Text } from '@chakra-ui/react';
// import ReactPlayer from 'react-player';
// const ReactPlayer = dynamic(() => import('react-player'));
/* Internal Imports */
/* Components */

/* Styles */
import StructuredTextParser from '@eternal/Components/Utility/StructuredTextParser';
import { render } from 'datocms-structured-text-to-html-string';

/* Services */

/**
 *
 * @param {Object} SectionContent
 * @param {String} lang
 * @param {String} region
 * @returns
 */
const HomeTopBanner = ({ sectionContent, region, lang }) => {
  const [navigatorObj, setNavigatorObj] = useState(true);
  let iOS = false;

  const iPhoneScreenHide = () => {
    var elVideo = document.getElementById('hideiOSVideo');
    iOS = /iPad|iPhone|iPod/.test(navigator?.userAgent) && !window.MSStream;
    console.log('iOS', iOS, navigator.userAgent);
    setNavigatorObj(navigator.userAgent);
    if (iOS) {
      elVideo.style.display = 'none';
    }
  };
  useEffect(() => {
    iPhoneScreenHide();
  }, []);

  return (
    <Box className="homeBanner" position="relative" bg="#040404">
      <Box
        height="100vh"
        // height={{
        //   base: `${section.viewH ? 'calc(100svh - 74px)' : 'auto'}`,
        //   md: '100%',
        // }}
        position="relative"
        minHeight="650px"
        backgroundSize="cover"
        backgroundImage={{
          base: `url(${sectionContent.mobileImage.url})`,
          md: `url(${sectionContent.desktopImage.url})`,
        }}
        maxH={{ base: 700, md: 830, xl: 1080 }}
        overflow="hidden"
        backgroundPosition="top"
      >
        <Box
          class="bkg"
          pos="absolute"
          top="0"
          width="100%"
          height="100%"
          bottom="0"
          zIndex={0}
          id="hideiOSVideo"
          left={0}
          right={0}
          _before={{
            content: "''",
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: '0',
            zIndex: '0',
            left: '0',
            background:
              'radial-gradient(91.3% 91.3% at 50% 8.7%, rgba(0, 0, 0, 0.00) 0%, #040404 100%)',
            mixBlendMode: 'normal',
            backgroundBlendMode: 'multiply',
          }}
        >
          <Box display={{ base: 'block', md: 'none' }} h="100%" w="100%">
            <video className="vid" loop muted autoPlay>
              <source
                src={sectionContent.mobileVideoLink}
                type="video/mp4"
                poster={sectionContent?.mobileImage?.url}
              />
            </video>
            {/* <ReactPlayer
              url={sectionContent.mobileVideoLink}
              playing={true}
              controls={false}
              muted={true}
              loop={true}
              width="100%"
              autoPlay={true}
              preload={true}
              height="100%"
              objectFit="cover"
              style={{
                height: '100%',
                width: '100%',
                objectFit: 'cover',
                objectPosition: 'top',
              }}
              className="vid"
            /> */}
          </Box>
          <Box display={{ base: 'none', md: 'block' }} h="100%" w="100%">
            <video className="vid" preload="auto" loop muted autoPlay>
              <source
                src={sectionContent.desktopVideoLink}
                // src="https://iso-videos-assets.s3.ap-south-1.amazonaws.com/videos/WhatsApp+Video+2023-09-22+at+17.03.17.mp4"
                type="video/mp4"
                poster={sectionContent?.desktopImage?.url}
              />
            </video>
            {/* <ReactPlayer
              url={sectionContent.desktopVideoLink}
              playing={true}
              controls={false}
              muted={true}
              loop={true}
              preload={true}
              width="100%"
              autoPlay={true}
              height="100vh"
              style={{
                height: '100%',
                width: '100%',
                objectFit: 'cover',
                objectPosition: 'top',
              }}
              objectFit="cover"
              className="vid"
            /> */}
          </Box>
        </Box>
        <Box
          pos="absolute"
          top={{ base: 'unset', md: 0 }}
          bottom={{ base: '0', md: '-32px' }}
          left="auto"
          right="auto"
          w="100%"
          h={{ base: 'auto', md: '100%' }}
          display="flex"
          mx="auto"
          justifyContent={{ base: 'flex-start', md: 'center' }}
          alignItems={{ base: 'center', md: 'flex-end' }}
          px={{ base: '7%', md: '0px' }}
          py={{ base: '0px', md: '0' }}
          zIndex={1}
        >
          <Flex flexDir="column" w="100%" pb={{ base: '40px', md: '5%' }}>
            <Text
              fontSize={{ base: '42px', md: '60px', lg: '80px', xl: '100px' }}
              as="h1"
              lineHeight={{ base: '52px', md: '76px', lg: '96px' }}
              fontFamily="FedraSerifAStdBook"
              textTransform="uppercase"
              color="#C9BAAB"
              textAlign="center"
              fontWeight="300"
            >
              {sectionContent?.title}
            </Text>
            <StructuredTextParser
              fontStyle="normal"
              fontSize={{ base: '16px', md: '20px', xl: '30px' }}
              lineHeight={{ base: '22px', md: '30px', xl: '40px' }}
              color="#F8FAFC"
              textAlign="center"
              marginTop={{
                base: '14px',
                md: '11px',
                xl: '10px',
                '2xl': '20px',
              }}
              fontFamily="FedraSansStd-book"
              str={render(sectionContent.titleSubtext.value)}
            />
          </Flex>
        </Box>
      </Box>
      <style>
        {`
          .bkg {
            display: flex;
            align-items: stretch;
            justify-content: center;
            height:100%;
            width: 100%;
            margin: 0 auto;
          }

          .vid {
            display: block;
            object-position: top;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          `}
      </style>
    </Box>
  );
};

export default HomeTopBanner;
